"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartTrialAction = exports.StartTrialCommand = exports.BuyPlanAction = exports.BuyPlanCommand = exports.UpgradePlanAction = exports.UpgradePlanCommand = exports.CheckoutCommands = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../utils/CardHelper");
const Command_1 = require("./Command");
var CheckoutCommands;
(function (CheckoutCommands) {
    CheckoutCommands["UpgradePlan"] = "checkout/upgrade";
    CheckoutCommands["BuyPlan"] = "checkout/buy";
    CheckoutCommands["StartTrial"] = "checkout/trial";
})(CheckoutCommands = exports.CheckoutCommands || (exports.CheckoutCommands = {}));
function UpgradePlanCommand() {
    const data = {
        command: CheckoutCommands.UpgradePlan,
    };
    return new Command_1.Command(data);
}
exports.UpgradePlanCommand = UpgradePlanCommand;
const UpgradePlanAction = (title) => {
    return CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: title || "Upgrade",
        data: UpgradePlanCommand().toTaskFetchCommand(),
    });
};
exports.UpgradePlanAction = UpgradePlanAction;
function BuyPlanCommand(trackingSource) {
    const data = {
        command: CheckoutCommands.BuyPlan,
        trackingSource,
    };
    return new Command_1.Command(data);
}
exports.BuyPlanCommand = BuyPlanCommand;
const BuyPlanAction = (trackingSource, title) => {
    return CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: title || "Subscribe",
        data: BuyPlanCommand(trackingSource).toTaskFetchCommand(),
    });
};
exports.BuyPlanAction = BuyPlanAction;
function StartTrialCommand(trackingSource) {
    const data = {
        command: CheckoutCommands.StartTrial,
        trackingSource,
    };
    return new Command_1.Command(data);
}
exports.StartTrialCommand = StartTrialCommand;
const StartTrialAction = (trackingSource, title) => {
    return CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: title || "Start Trial",
        data: StartTrialCommand(trackingSource).toTaskFetchCommand(),
    });
};
exports.StartTrialAction = StartTrialAction;
//# sourceMappingURL=CheckoutCommands.js.map